module.exports = __webpack_public_path__ + "static/media/vscode.edaa26c0.svg";